var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "contractDesignInfoForm",
      staticClass: "form-container",
      attrs: { model: _vm.form, size: "small", "label-width": "140px" },
    },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "导购", prop: "guide" } },
                [
                  _vm._l(_vm.guideUserList, function (item) {
                    return _c(
                      "el-tag",
                      { staticStyle: { "margin-right": "2px" } },
                      [_vm._v(_vm._s(item))]
                    )
                  }),
                  _vm._v(" "),
                  _vm.editable &&
                  _vm.$parent.checkPer(["admin", "contract:edit"])
                    ? _c("el-button", {
                        attrs: { icon: "el-icon-plus" },
                        on: {
                          click: function ($event) {
                            return _vm.onUserSelect("门店导购")
                          },
                        },
                      })
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "设计中心派单员", prop: "dispatcher" } },
                [
                  _vm._l(_vm.dispatcherUserList, function (item) {
                    return _c(
                      "el-tag",
                      { staticStyle: { "margin-right": "2px" } },
                      [_vm._v(_vm._s(item))]
                    )
                  }),
                  _vm._v(" "),
                  _vm.editable &&
                  _vm.$parent.checkPer(["admin", "contract:edit"])
                    ? _c("el-button", {
                        attrs: { icon: "el-icon-plus" },
                        on: {
                          click: function ($event) {
                            return _vm.onUserSelect("设计中心派单员")
                          },
                        },
                      })
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "设计师", prop: "designer" } },
                [
                  _vm._l(_vm.designerUserList, function (item) {
                    return _c(
                      "el-tag",
                      { staticStyle: { "margin-right": "2px" } },
                      [_vm._v(_vm._s(item))]
                    )
                  }),
                  _vm._v(" "),
                  _vm.editable &&
                  _vm.$parent.checkPer(["admin", "contract:edit"])
                    ? _c("el-button", {
                        attrs: { icon: "el-icon-plus" },
                        on: {
                          click: function ($event) {
                            return _vm.onUserSelect("设计师")
                          },
                        },
                      })
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "效果图组对接人", prop: "contactPerson" } },
                [
                  _vm._l(_vm.contactPersonUserList, function (item) {
                    return _c(
                      "el-tag",
                      { staticStyle: { "margin-right": "2px" } },
                      [_vm._v(_vm._s(item))]
                    )
                  }),
                  _vm._v(" "),
                  _vm.editable &&
                  _vm.$parent.checkPer(["admin", "contract:edit"])
                    ? _c("el-button", {
                        attrs: { icon: "el-icon-plus" },
                        on: {
                          click: function ($event) {
                            return _vm.onUserSelect("效果图组对接人")
                          },
                        },
                      })
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "下单员", prop: "orderClerk" } },
                [
                  _vm._l(_vm.orderClerkUserList, function (item) {
                    return _c(
                      "el-tag",
                      { staticStyle: { "margin-right": "2px" } },
                      [_vm._v(_vm._s(item))]
                    )
                  }),
                  _vm._v(" "),
                  _vm.editable &&
                  _vm.$parent.checkPer(["admin", "contract:edit"])
                    ? _c("el-button", {
                        attrs: { icon: "el-icon-plus" },
                        on: {
                          click: function ($event) {
                            return _vm.onUserSelect("下单员")
                          },
                        },
                      })
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "是否测未定", prop: "unmeasured" } },
                [
                  _vm.form.unmeasured
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            width: "100%",
                            padding: "10px",
                            border: "1px solid #dcdfe6",
                            "border-radius": "4px",
                            "background-color": "#f5f7fa",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.form.unmeasured) +
                              "\n        "
                          ),
                        ]
                      )
                    : _c("span", { staticStyle: { color: "#c0c4cc" } }, [
                        _vm._v("暂无"),
                      ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "派测量" } },
                [
                  !_vm.form.planMeasureTime &&
                  _vm.editable &&
                  _vm.$parent.checkPer(["admin", "contract:edit"])
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.openMeasureDialog },
                        },
                        [_vm._v("派测量")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "定位", prop: "positioning" } },
                [
                  _vm.form.positioning
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-right": "10px",
                            "margin-bottom": "10px",
                            "word-break": "break-all",
                          },
                        },
                        [_vm._v(_vm._s(_vm.form.positioning))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editable &&
                  _vm.$parent.checkPer(["admin", "contract:edit"])
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.openMapSelector },
                        },
                        [_vm._v("选择位置")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "测量时间", prop: "measureTime" } },
                [
                  _vm.form.measureTime
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            width: "100%",
                            padding: "10px",
                            border: "1px solid #dcdfe6",
                            "border-radius": "4px",
                            "background-color": "#f5f7fa",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.formatTime(_vm.form.measureTime)) +
                              "\n        "
                          ),
                        ]
                      )
                    : !_vm.form.measureTime && _vm.editable
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { type: "primary" },
                          on: { click: _vm.handleMeasured },
                        },
                        [_vm._v("\n          标记为已测量\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "复尺时间", prop: "recoveryTime" } },
                [
                  _vm.form.recoveryTime
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            width: "100%",
                            padding: "10px",
                            border: "1px solid #dcdfe6",
                            "border-radius": "4px",
                            "background-color": "#f5f7fa",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.formatTime(_vm.form.recoveryTime)) +
                              "\n        "
                          ),
                        ]
                      )
                    : !_vm.form.recoveryTime && _vm.editable
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSizeVerified },
                        },
                        [_vm._v("\n          标记为已复尺\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "确认方案时间", prop: "confirmPlanTime" } },
                [
                  _vm.form.confirmPlanTime
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            width: "100%",
                            padding: "10px",
                            border: "1px solid #dcdfe6",
                            "border-radius": "4px",
                            "background-color": "#f5f7fa",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.formatTime(_vm.form.confirmPlanTime)) +
                              "\n        "
                          ),
                        ]
                      )
                    : !_vm.form.confirmPlanTime && _vm.editable
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { type: "primary" },
                          on: { click: _vm.handleConfirmPlan },
                        },
                        [_vm._v("\n          标记为已确认方案\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "签单时间", prop: "contractTime" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "date",
                      placeholder: "选择签单时间",
                      disabled:
                        !_vm.editable ||
                        !_vm.$parent.checkPer(["admin", "contract:edit"]),
                    },
                    model: {
                      value: _vm.form.contractTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "contractTime", $$v)
                      },
                      expression: "form.contractTime",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _vm.form.planMeasureTime
            ? _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "计划测量时间", prop: "planMeasureTime" },
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          placeholder: "请选择计划测量时间",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          disabled:
                            !_vm.editable ||
                            !_vm.$parent.checkPer(["admin", "contract:edit"]),
                        },
                        model: {
                          value: _vm.form.planMeasureTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "planMeasureTime", $$v)
                          },
                          expression: "form.planMeasureTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.form.planMeasureTime
            ? _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "派测量要求", prop: "measureText" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 2,
                          placeholder: "请输入派测量要求",
                          disabled:
                            !_vm.editable ||
                            !_vm.$parent.checkPer(["admin", "contract:edit"]),
                        },
                        model: {
                          value: _vm.form.measureText,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "measureText", $$v)
                          },
                          expression: "form.measureText",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "签字日期", prop: "signatureDate" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "date",
                      placeholder: "选择签字日期",
                      disabled:
                        !_vm.editable ||
                        !_vm.$parent.checkPer(["admin", "contract:edit"]),
                    },
                    model: {
                      value: _vm.form.signatureDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "signatureDate", $$v)
                      },
                      expression: "form.signatureDate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "预计交货日期",
                    prop: "scheduledDeliveryDate",
                  },
                },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "date",
                      placeholder: "选择预计交货日期",
                      disabled:
                        !_vm.editable ||
                        !_vm.$parent.checkPer(["admin", "contract:edit"]),
                    },
                    model: {
                      value: _vm.form.scheduledDeliveryDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "scheduledDeliveryDate", $$v)
                      },
                      expression: "form.scheduledDeliveryDate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "约定工期（天数）",
                    prop: "agreedConstructionPeriod",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入约定工期（天数）",
                      disabled:
                        !_vm.editable ||
                        !_vm.$parent.checkPer(["admin", "contract:edit"]),
                    },
                    model: {
                      value: _vm.form.agreedConstructionPeriod,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "agreedConstructionPeriod", $$v)
                      },
                      expression: "form.agreedConstructionPeriod",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "效果图对接人附件",
                    prop: "contactPersonFile",
                  },
                },
                [
                  _vm.editable
                    ? _c("oss-upload", {
                        ref: "contactPersonFileUpload",
                        attrs: {
                          "upload-type": "file",
                          multiple: true,
                          accept: ".pdf,.zip,.rar,.7z,.doc,.docx,.xls,.xlsx",
                          "oss-dir": "crm/design/contact/",
                        },
                        on: {
                          "upload-success": _vm.handleContactPersonFileUpload,
                          "delete-success": _vm.handleContactPersonFileDelete,
                        },
                      })
                    : _vm.contactPersonFileAttachments.length > 0
                    ? _c(
                        "div",
                        _vm._l(
                          _vm.contactPersonFileAttachments,
                          function (file, idx) {
                            return _c(
                              "a",
                              {
                                key: idx,
                                staticStyle: {
                                  display: "block",
                                  "margin-bottom": "4px",
                                },
                                attrs: { href: file.url, target: "_blank" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    file.alias || file.realName || file.name
                                  )
                                ),
                              ]
                            )
                          }
                        ),
                        0
                      )
                    : _c("span", { staticStyle: { color: "#c0c4cc" } }, [
                        _vm._v("暂无附件"),
                      ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "下单员附件", prop: "orderClerkFile" } },
                [
                  _vm.editable
                    ? _c("oss-upload", {
                        ref: "orderClerkFileUpload",
                        attrs: {
                          "upload-type": "file",
                          multiple: true,
                          accept: ".pdf,.zip,.rar,.7z,.doc,.docx,.xls,.xlsx",
                          "oss-dir": "crm/design/orderclerk/",
                        },
                        on: {
                          "upload-success": _vm.handleOrderClerkFileUpload,
                          "delete-success": _vm.handleOrderClerkFileDelete,
                        },
                      })
                    : _vm.orderClerkFileAttachments.length > 0
                    ? _c(
                        "div",
                        _vm._l(
                          _vm.orderClerkFileAttachments,
                          function (file, idx) {
                            return _c(
                              "a",
                              {
                                key: idx,
                                staticStyle: {
                                  display: "block",
                                  "margin-bottom": "4px",
                                },
                                attrs: { href: file.url, target: "_blank" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    file.alias || file.realName || file.name
                                  )
                                ),
                              ]
                            )
                          }
                        ),
                        0
                      )
                    : _c("span", { staticStyle: { color: "#c0c4cc" } }, [
                        _vm._v("暂无附件"),
                      ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "审单反馈附件", prop: "feedbackFile" } },
                [
                  _vm.editable
                    ? _c("oss-upload", {
                        ref: "feedbackFileUpload",
                        attrs: {
                          "upload-type": "file",
                          multiple: true,
                          accept: ".pdf,.zip,.rar,.7z,.doc,.docx,.xls,.xlsx",
                          "oss-dir": "crm/design/feedback/",
                        },
                        on: {
                          "upload-success": _vm.handleFeedbackFileUpload,
                          "delete-success": _vm.handleFeedbackFileDelete,
                        },
                      })
                    : _vm.feedbackFileAttachments.length > 0
                    ? _c(
                        "div",
                        _vm._l(
                          _vm.feedbackFileAttachments,
                          function (file, idx) {
                            return _c(
                              "a",
                              {
                                key: idx,
                                staticStyle: {
                                  display: "block",
                                  "margin-bottom": "4px",
                                },
                                attrs: { href: file.url, target: "_blank" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    file.alias || file.realName || file.name
                                  )
                                ),
                              ]
                            )
                          }
                        ),
                        0
                      )
                    : _c("span", { staticStyle: { color: "#c0c4cc" } }, [
                        _vm._v("暂无附件"),
                      ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择位置",
            visible: _vm.mapDialogVisible,
            width: "800px",
            height: "600px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.mapDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "margin-bottom": "10px",
                position: "relative",
                width: "70%",
              },
            },
            [
              _c(
                "el-input",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请输入地址关键词搜索" },
                  on: { input: _vm.handleSearchInput },
                  model: {
                    value: _vm.searchKeyword,
                    callback: function ($$v) {
                      _vm.searchKeyword = $$v
                    },
                    expression: "searchKeyword",
                  },
                },
                [
                  _c("el-button", {
                    attrs: { slot: "append", icon: "el-icon-search" },
                    on: { click: _vm.searchLocation },
                    slot: "append",
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.showSearchResults && _vm.searchResults.length > 0
                ? _c(
                    "div",
                    { staticClass: "search-results" },
                    _vm._l(_vm.searchResults, function (result, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "search-result-item",
                          on: {
                            click: function ($event) {
                              return _vm.selectSearchResult(result)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "el-icon-location" }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(result.name) +
                                _vm._s(
                                  result.address ? " " + result.address : ""
                                )
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", {
            staticStyle: { width: "100%", height: "500px" },
            attrs: { id: "mapContainer" },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.mapDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmMapSelection },
                },
                [_vm._v("确认选择")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "派测量",
            visible: _vm.measureDialogVisible,
            width: "500px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.measureDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.measureForm,
                "label-width": "120px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "计划测量时间", prop: "planMeasureTime" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "datetime",
                      placeholder: "请选择计划测量时间",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      clearable: "",
                    },
                    model: {
                      value: _vm.measureForm.planMeasureTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.measureForm, "planMeasureTime", $$v)
                      },
                      expression: "measureForm.planMeasureTime",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "派测量要求", prop: "measureText" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      placeholder: "请输入派测量要求",
                    },
                    model: {
                      value: _vm.measureForm.measureText,
                      callback: function ($$v) {
                        _vm.$set(_vm.measureForm, "measureText", $$v)
                      },
                      expression: "measureForm.measureText",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.measureDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitMeasure },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("UserSelect", {
        ref: "userSelect",
        attrs: { "show-user-select": _vm.showUserSelect },
        on: {
          close: _vm.onUserSelectClose,
          "select-user-callBack": _vm.selectUserCallBack,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "margin-top": "20px", "text-align": "right" } },
        [
          _vm.editable && _vm.$parent.checkPer(["admin", "contract:edit"])
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveDesignInfo },
                },
                [_vm._v("保存设计信息")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }